import { writable } from "svelte/store";

export const onBreak = writable();